import { EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";

export const editAction = () => {
    return (props) => {
        // eslint-disable-next-line no-unused-vars
        const { component: MenuItem, onClick, params, ...restProps } = props;

        const { id } = params;
        const value = "edit";
        const label = "Edit";

        const navigate = useNavigate();
        const handleOnClick = () => {
            navigate(`edit/${id}`);
            onClick(value);
        };
        return (
            <MenuItem
                key={value}
                value={value}
                label={value}
                icon={<EditOutlined />}
                onClick={handleOnClick}
                {...restProps}
            >
                {label}
            </MenuItem>
        );
    };
};
